// import 'events-polyfill' -> causes problems with the flockler carousel

window.breakpoints = {
  current: "",
  breakpoints: [],

  bootrap_breakpoints: {
    xs: "(max-width: 575px)",
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)",
  },

  match: function () {
    try {
      //reset
      window.breakpoints.breakpoints = [];

      var breakpoints = window.breakpoints.bootrap_breakpoints;

      for (var breakpoint in breakpoints) {
        var mql = window.matchMedia(breakpoints[breakpoint]);
        if (mql.matches === true) {
          window.breakpoints.breakpoints.push(breakpoint);
        }
      }

      return window.breakpoints.breakpoints;
    } catch (e) {
      // alert(e)
    }
  },
  get: function () {
    //console.log($.breakpoints.breakpoints);
  },

  change: function () {
    var breakpoints = window.breakpoints.match();
    if (breakpoints) {
      var breakpoint = breakpoints.slice(-1).pop();
      var breakpoint_without_touch = breakpoint;

      if (breakpoint === "bp-touch") {
        breakpoints.pop();
        breakpoint_without_touch = breakpoints.slice(-1).pop();
      }

      if (window.breakpoints.current !== breakpoint) {
        //fire event
        var event = new Event("breakpointchanged");
        event.breakpoint = breakpoint;
        window.dispatchEvent(event);
      }

      window.breakpoints.current = breakpoint;
      window.breakpoints.current_without_touch = breakpoint_without_touch;
    }
  },
};

window.addEventListener(
  "resize",
  function () {
    window.breakpoints.change();
  },
  false,
);

//initial
window.breakpoints.change();
